// src/components/OfferCard.js
import React from "react";
import "../styles/OfferCard.css";
import fallbackImage from "../assets/images/PriniCrackers.jpg";

const OfferCard = ({ offer, phoneNumber }) => {
  return (
    <div className="offer-card">
      <div className="offer-header">
        <span className="offer-discount">{offer.discount}</span>
        <h3>{offer.title}</h3>
      </div>

      <div
        className="offer-img-wrapper"
        style={{ backgroundImage: `url(${offer.image || fallbackImage})` }}
        aria-label={offer.title}
        role="img"
      ></div>

      <p>{offer.description}</p>

      {/* Conditionally render the "Use Code" section */}
      {offer.code && (
        <p className="offer-code">
          Use Code: <strong>{offer.code}</strong>
        </p>
      )}

      {/* WhatsApp link with dynamic phone number from offerData.contact */}
      <a
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(
          `Hi! I'm interested in the ${offer.title} (${offer.code}) offer.`
        )}`}
        className="offer-btn"
        target="_blank"
        rel="noopener noreferrer"
      >
        Claim via WhatsApp
      </a>
    </div>
  );
};

export default OfferCard;
